import { Box, Tooltip, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { badgeStyles, badgeTooltipSlotProps, BadgeSize, BadgeVariant } from './Badge.styles';

export const SMALL_GROUPS_TOOLTIP = 'Experiences published using this Master require the use of small student groups.';
export const READING_GROUPS_TOOLTIP = 'Experiences published using this Master require the use of reading groups.';
export const TEACHER_NAV_TOOLTIP = 'Teachers will be able to control student navigation in Experiences published using this Master.';

export interface BadgeProps {
  text: string | number;
  label?: string;
  tooltip?: string;
  variant?: BadgeVariant;
  size?: BadgeSize;
  bordered?: boolean;
}

export const Badge = ({
  text,
  label,
  tooltip,
  variant = 'primary',
  size = 'regular',
  bordered = false,
}: BadgeProps) => {
  const theme = useTheme();

  const badgeContent = (
    <Box sx={badgeStyles.badge(theme, { variant, size, bordered })}>
      {text}
    </Box>
  );

  const renderedBadge = tooltip ? (
    <Tooltip title={tooltip} arrow slotProps={badgeTooltipSlotProps}>
      {badgeContent}
    </Tooltip>
  ) : (
    badgeContent
  );

  if (!label) {
    return renderedBadge;
  }

  return (
    <Box sx={badgeStyles.container()}>
      <Typography sx={badgeStyles.label(theme)}>{label}</Typography>
      {renderedBadge}
    </Box>
  );
};

export default Badge;
